import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { API, USER } from "./variables"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    places: [],
    status: localStorage.getItem('status') || '',
    error: '',
    token: localStorage.getItem('token') || '',
    lang: 'ca',
  },
  mutations: {
    auth_web(state, token) {
      state.status = 'web';
      localStorage.setItem('status', 'web');
      state.token = token;
    },
    auth_request(state) {
      state.status = 'loading';
    },
    auth_error(state, error) {
      state.status = 'error';
      localStorage.setItem('status', 'error');
      state.error = error;
    },
    auth_logout(state) {
      state.status = 'out';
      localStorage.setItem('status', 'out');
      state.token = '';
    },
    language(state, lang) {
      state.lang = lang;
    },
    setPlaces(state, places) {
      state.places = places;
    },
    changeLanguage(state, lang){
      state.lang = lang
    }
  },
  actions: {
    webLogin({commit}) {
      return new Promise((resolve, reject) => {

        const headers = {
          "Content-type": "application/json",
        }

        axios.post(API.protocol + API.ip + '/user/login?_format=json', {
          name: USER.name,
          pass: USER.pass
        }, {headers: headers})
          .then((resp) => {
            if (resp.status === 200) {
              const token = resp.data.csrf_token;
              localStorage.setItem('token', token);
              axios.defaults.headers.common['X-CSRF-Token'] = token;
              commit('auth_web', token);
              resolve(resp);
            } else {
              commit('auth_logout');
              localStorage.removeItem('token');
              reject();
            }
          })
          .catch((err) => {
            commit('auth_logout');
            localStorage.removeItem('token');
            reject(err);
          });
      })
    },
    sessionToken({commit}) {
      return new Promise((resolve, reject) => {
        axios.get(API.protocol + API.ip + '/rest/session/token')
          .then((resp) => {
            localStorage.setItem('token', resp.data);
            axios.defaults.headers.common['X-CSRF-Token'] = resp.data;
            resolve(resp);
          })
          .catch((err) => {
            localStorage.removeItem('token');
            reject(err);
          })
      })
    }
  },
  getters: {}
})
